/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetDeliverySchedulesByOrderId(data) {
  const response = await $.soap({
    body: {
      GetDeliverySchedulesByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order_delivery_schedule',
        OrderID: data.orderId,
        OrderTypeID: data.orderTypeId
      }
    },
    blueprintArrays: ['GetDeliverySchedulesByOrderIdResponse.DeliverySchedules.CustomerOrderDeliverySchedule'],
    blueprint: {
      schedules: [
        'GetDeliverySchedulesByOrderIdResponse.DeliverySchedules.CustomerOrderDeliverySchedule',
        {
          id: '$.DeliveryScheduleID',
          address: {
            addressLine1: '$.Address1',
            addressLine2: '$.Address2',
            buildingFloorNumber: '$.BuildingFloorNumber',
            floorNumber: '$.FloorNumber',
            roomNumber: '$.RoomNumber',
            poleNumber: '$.PoleNumber',
            suite: '$.Suite',
            roomPoleNumber: '$.RoomPoleNumber',
            city: '$.City',
            zip: '$.Zip',
            regionId: '$.RegionID',
            regionCode: '$.RegionCode',
            regionName: '$.RegionName',
            isConus: '$.IsCONUS'
          },
          device: {
            clin: '$.CLIN',
            equipmentName: '$.EquipmentName',
            lineNumber: '$.LineNumber',
            customDescription: '$.CustomDescription',
            price: '$.Price',
            volumeBand: '$.VolumeBand',
            warrantyYear: '$.WarrantyYear',
            model: '$.Model',
            laserPrinterTonerCartridgeType: '$.LaserPrinterTonerCartridgeType',
            description: '$.Description',
            paperCapacityHandling: '$.PaperCapacityHandling',
            configurationAndPricing: '$.ConfigurationAndPricing',
            isNipr: '$.IsNIPR',
            isColor: '$.IsColor',
            speedPPM: '$.SpeedPPM',
            optionalAccessories: '$.OptionalAccessories'
          },
          deliveryPOCFirstName: '$.DeliveryPOCFirstName',
          deliveryPOCLastName: '$.DeliveryPOCLastName',
          deliveryPOCEmail: '$.DeliveryPOCEmail',
          deliveryPOCPhone: '$.DeliveryPOCPhone',
          itPOCFirstName: '$.ITPOCFirstName',
          itPOCLastName: '$.ITPOCLastName',
          itPOCEmail: '$.ITPOCEmail',
          itPOCPhone: '$.ITPOCPhone',
          finPOCFirstName: '$.FinPOCFirstName',
          finPOCLastName: '$.FinPOCLastName',
          finPOCEmail: '$.FinPOCEmail',
          finPOCPhone: '$.FinPOCPhone',
          termingSerialNumber: '$.TermingSerialNumber',
          isReplacement: '$.IsReplacement',
          network: '$.Network',
          trainingType: '$.TrainingType',
          trainingTypeId: '$.TrainingTypeID',
          additionalServiceId: '$.AdditionalServiceID',
          additionalServiceCLIN: '$.AdditionalServiceCLIN',
          additionalService: '$.AdditionalService',
          additionalAccessoryId: '$.AdditionalAccessoryID',
          additionalAccessoryCLIN: '$.AdditionalAccessoryCLIN',
          additionalAccessory: '$.AdditionalAccessory',
          mfdAdditionalService: '$.MFDAdditionalService',
          commandEchelon: '$.CommandEchelon',
          trackerNumber: '$.TrackerNumber',
          note: '$.Note'
        }
      ]
    }
  });

  cleanUpResponse(response);

  _.each(response.schedules, (deliverySchedule) => {
    deliverySchedule.deliveryPOCName = deliverySchedule.deliveryPOCFirstName
      ? `${deliverySchedule.deliveryPOCFirstName} ${deliverySchedule.deliveryPOCLastName}`
      : null;
    deliverySchedule.itPOCName = deliverySchedule.itPOCFirstName
      ? `${deliverySchedule.itPOCFirstName} ${deliverySchedule.itPOCLastName}`
      : null;
    deliverySchedule.finPOCName = deliverySchedule.finPOCFirstName
      ? `${deliverySchedule.finPOCFirstName} ${deliverySchedule.finPOCLastName}`
      : null;
  });

  return response.schedules;
}
